import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { AppWrapper } from './AppWrapper';
import './index.css';

// Dev-only imports (tree-shaken in production)
if (import.meta.env.DEV) {
  import('./dev/syncTestHelpers');
}

/**
 * App Entry Point - Clean Architecture with HeroUI Routing Integration
 *
 * Sets up:
 * - HeroUIProvider with React Router integration for seamless navigation
 * - BrowserRouter for routing
 * - navigate and useHref functions for HeroUI components
 * - Clean App component with minimal playground routes
 * - Dev test helpers (tree-shaken in production)
 */

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('Failed to find root element');
}

ReactDOM.createRoot(rootElement).render(
  <React.StrictMode>
    <BrowserRouter
      future={{
        v7_startTransition: true,
        v7_relativeSplatPath: true
      }}
    >
      <AppWrapper />
    </BrowserRouter>
  </React.StrictMode>
);